import axios from "axios";
import store from "@/store";

export const connection = function(options) {
  const {
    api,
    data,
    failMessage,
    method,
    mutation = "",
    name,
    params,
    url
  } = options;

  let headers = {
    ...store.state.auth.apis[api].headers,
    Authorization: `Bearer ${store.state.auth.token}`
  };

  const instance = axios.create({
    url: `${store.state.auth.apis[api].url}/${url}`,
    method,
    headers,
    params,
    data
  });

  instance.interceptors.request.use(
    function(config) {
      store.commit(mutation, { name, loading: true }, { root: true });
      return config;
    },
    function(error) {
      store.commit(mutation, { name, loading: false }, { root: true });
      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    function(response) {
      store.commit(mutation, { name, loading: false }, { root: true });
      return response.data;
    },
    function(error) {
      store.commit(mutation, { name, loading: false }, { root: true });
      store.dispatch(
        "snackbar/add",
        {
          text: failMessage,
          open: true,
          timeout: 0
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  );

  const request = instance.request();

  return request;
};
